export const ANIMAL_CATEGORIES = [
  { id: 'AT', descricao: 'Animal Ativo' },
  { id: 'VD', descricao: 'Animal Vendido' },
  { id: 'MT', descricao: 'Animal Morto' }
]
export const ANIMAL_CATEGORY_MAP: Record<string, string> = {
  AT: 'Animal Ativo',
  VD: 'Animal Vendido',
  MT: 'Animal Morto'
}
